import { createContext } from 'react';

export const TwilioDeviceContext = createContext(null);
